exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar{position:fixed;height:60px;width:100%}.upNav{height:40px;background:rgba(0,0,0,.2)}.theme--dark.v-app-bar.v-toolbar.v-sheet{background:transparent}.video-example{top:-215px}#link_upnav{color:#fff}@media (min-width:1024px){.navbar{width:100%!important}.upNav{padding:5px}}@media (min-width:960px){.default_width,.default_width__video{max-width:100%}}@media (min-width:768px){#fit{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}}.full{position:absolute;top:0;left:0;height:100%;width:100%;-o-object-fit:cover;object-fit:cover}", ""]);

// exports
